/* ==========================================================================
   Farmahanem Collection — filtre paneli UX geliştirmeleri
   --------------------------------------------------------------------------
   Uzun filtre listeleri (marka: koleksiyon başına 48-75 değer) için arama
   kutusu ve kendi içinde kayan liste; fiyat için hazır aralık butonları;
   mobil sticky araç çubuğundaki sıralama çiplerinin senkronu.

   Tamamen progressive enhancement: JS çalışmazsa filtreler Symmetry'nin
   varsayılan hâliyle sorunsuz çalışmaya devam eder. Symmetry'nin kendi
   dosyalarına (main.js / faceted-filters.liquid) dokunmaz.
   ========================================================================== */

(() => {
  'use strict';

  const ENHANCE_AFTER = 10;   // bu sayıdan az seçeneği olan grup olduğu gibi kalır
  const SEARCH_AFTER = 12;    // bu sayıdan fazla seçenek varsa arama kutusu ekle

  const config = readConfig();

  // Arama terimleri AJAX yeniden render'ını atlatsın diye burada tutuluyor.
  // Anahtar: filtrenin param adı (ör. "filter.p.vendor") — AJAX sonrası sabit.
  const searchTerms = new Map();

  /** Tema tarafından basılan etiket/ayar bloğunu oku. */
  function readConfig() {
    const fallback = {
      labels: {
        search_placeholder: 'Ara…',
        no_match: 'Eşleşen seçenek yok',
        clear_filters: 'Filtreleri temizle',
        price_bands: 'Hızlı aralık'
      },
      price_bands: [],
      currency_symbol: ''
    };
    const el = document.getElementById('FhCollectionConfig');
    if (!el) return fallback;
    try {
      const parsed = JSON.parse(el.textContent);
      return {
        labels: Object.assign({}, fallback.labels, parsed.labels || {}),
        price_bands: Array.isArray(parsed.price_bands) ? parsed.price_bands : [],
        currency_symbol: parsed.currency_symbol || ''
      };
    } catch (e) {
      return fallback;
    }
  }

  /* ──────────────────────────────────────────────────────────────────── */
  /* Uzun filtre listeleri: arama kutusu + kayan liste                    */
  /* ──────────────────────────────────────────────────────────────────── */

  function enhanceListGroup(group) {
    if (group.dataset.farmahanemEnhanced === 'true') return;

    const container = group.querySelector('.toggle-target-container');
    if (!container) return;

    const items = Array.from(container.querySelectorAll('label.filter-group__item'))
      .filter((el) => el.querySelector('input[type="checkbox"]'));
    if (items.length <= ENHANCE_AFTER) return;

    group.dataset.farmahanemEnhanced = 'true';
    group.classList.add('fh-filter-group--enhanced');

    // Grup anahtarı olarak filtrenin param adını kullan — AJAX render'ları
    // arasında sabit kaldığı için hem arama terimi hem focus geri gelir.
    const firstCheckbox = items[0].querySelector('input[type="checkbox"]');
    const groupKey = (firstCheckbox && firstCheckbox.name) || 'fh-group';
    const uid = `fh-fg-${groupKey.replace(/[^a-zA-Z0-9]+/g, '-')}`;

    // ── Arama kutusu ──────────────────────────────────────────────────
    let searchInput = null;
    if (items.length > SEARCH_AFTER) {
      const wrap = document.createElement('div');
      wrap.className = 'fh-filter-search';

      searchInput = document.createElement('input');
      searchInput.type = 'search';
      searchInput.className = 'fh-filter-search__input';
      searchInput.id = `${uid}-search`;
      searchInput.placeholder = config.labels.search_placeholder;
      searchInput.setAttribute('aria-label', config.labels.search_placeholder);
      searchInput.autocomplete = 'off';
      // Bu kutu bir filtre değeri DEĞİL. Symmetry'nin ajaxLoadForm'u
      // `.filters` içindeki TÜM input'ları toplayıp query string'e ekliyor;
      // bu işaret sayesinde filtre değişiminden hemen önce boşaltılıyor
      // (bkz. clearSearchInputs) ve URL'e sızmıyor.
      searchInput.dataset.farmahanemFilterSearch = groupKey;
      searchInput.value = searchTerms.get(groupKey) || '';

      wrap.appendChild(searchInput);
      container.insertBefore(wrap, container.firstChild);
    }

    // ── Seçenekleri kendi kabuğuna al ────────────────────────────────
    // Böylece uzun listede yalnızca seçenekler kayar; arama kutusu ve
    // "daha fazla göster" sabit kalır.
    const list = document.createElement('div');
    list.className = 'fh-filter-list';
    container.insertBefore(list, items[0]);
    items.forEach((item) => list.appendChild(item));

    const empty = document.createElement('p');
    empty.className = 'fh-filter-empty';
    empty.hidden = true;
    empty.textContent = config.labels.no_match;
    container.appendChild(empty);

    /**
     * Arama terimine göre görünürlüğü hesapla.
     * Katlama YOK — tüm değerler listelenir, uzun liste kendi içinde kayar
     * (bkz. .fh-filter-list max-height).
     */
    function apply() {
      const term = (searchInput ? searchInput.value : '').trim().toLocaleLowerCase('tr');
      let matches = 0;

      items.forEach((item) => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        const text = (item.textContent || '').trim().toLocaleLowerCase('tr');

        // Seçili bir değer asla gizlenmez — formdan düşmesin, kullanıcı
        // neyi seçtiğini görsün.
        if (checkbox && checkbox.checked) {
          item.hidden = false;
          matches += 1;
          return;
        }

        const matchesTerm = term === '' || text.indexOf(term) !== -1;
        item.hidden = !matchesTerm;
        if (matchesTerm) matches += 1;
      });

      empty.hidden = matches !== 0;
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        searchTerms.set(groupKey, searchInput.value);
        apply();
      });
      // Enter arama kutusundayken formu göndermesin.
      searchInput.addEventListener('keydown', (evt) => {
        if (evt.key === 'Enter') evt.preventDefault();
      });
    }

    apply();
  }

  /* ──────────────────────────────────────────────────────────────────── */
  /* Fiyat: hazır aralık butonları                                        */
  /* ──────────────────────────────────────────────────────────────────── */

  function enhancePriceGroup(root) {
    if (!config.price_bands.length) return;

    const priceRange = root.querySelector('price-range.cc-price-range');
    if (!priceRange || priceRange.dataset.farmahanemEnhanced === 'true') return;

    const minInput = priceRange.querySelector('.cc-price-range__input--min');
    const maxInput = priceRange.querySelector('.cc-price-range__input--max');
    if (!minInput || !maxInput) return;

    priceRange.dataset.farmahanemEnhanced = 'true';

    const bands = document.createElement('div');
    bands.className = 'fh-price-bands';
    bands.setAttribute('role', 'group');
    bands.setAttribute('aria-label', config.labels.price_bands);

    config.price_bands.forEach((band) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fh-price-band';
      btn.textContent = band.label;

      const isActive = String(minInput.value || '') === String(band.min || '')
        && String(maxInput.value || '') === String(band.max || '');
      if (isActive) btn.classList.add('fh-price-band--active');

      btn.addEventListener('click', () => {
        // Aynı banda tekrar basmak seçimi temizler.
        if (btn.classList.contains('fh-price-band--active')) {
          minInput.value = '';
          maxInput.value = '';
        } else {
          minInput.value = band.min == null ? '' : String(band.min);
          maxInput.value = band.max == null ? '' : String(band.max);
        }
        // Symmetry'nin form dinleyicisi `change` bekliyor (bubbling şart).
        maxInput.dispatchEvent(new Event('change', { bubbles: true }));
      });

      bands.appendChild(btn);
    });

    priceRange.insertBefore(bands, priceRange.firstChild);
  }

  /* ──────────────────────────────────────────────────────────────────── */
  /* "Filtreleri temizle" butonu — panelin en üstünde                     */
  /* ──────────────────────────────────────────────────────────────────── */

  /**
   * "Filtreleri temizle" butonunu panelin en üstüne kurar.
   *
   * Neden Symmetry'ninki kullanılmıyor: onun temizle bağlantısı yalnızca
   * "uygulanan filtre çipi" varsa basılıyor, stok durumu (filter.v.availability)
   * ise bilerek çip üretmiyor. Sonuç: "Gizle" seçiliyken sayaç (1) diyor ama
   * temizlenecek hiçbir şey görünmüyordu. Bu buton URL'deki HERHANGİ bir
   * `filter.` parametresine bakıyor, stok dahil.
   *
   * `filter-group__clear-link` sınıfı bilerek veriliyor: main.js'teki AJAX
   * tıklama dinleyicisi bu seçiciye bağlı.
   */
  function ensureClearButton(inner) {
    const params = new URLSearchParams(window.location.search);
    let hasFilter = false;
    params.forEach((_value, key) => {
      if (key.indexOf('filter.') === 0) hasFilter = true;
    });

    const existing = inner.querySelector('.fh-clear-filters');

    if (!hasFilter) {
      if (existing) existing.remove();
      return;
    }

    // Sıralama tercihi korunur; temizlemek yalnızca filtreleri sıfırlar.
    const sort = params.get('sort_by');
    const href = window.location.pathname + (sort ? `?sort_by=${encodeURIComponent(sort)}` : '');

    if (existing) {
      // Zaten yerinde — MutationObserver sonsuz döngüye girmesin.
      if (existing.getAttribute('href') === href) return;
      existing.setAttribute('href', href);
      return;
    }

    const link = document.createElement('a');
    link.className = 'fh-clear-filters filter-group__clear-link';
    link.href = href;
    link.textContent = config.labels.clear_filters;

    const heading = inner.querySelector('.filters__heading');
    if (heading) heading.insertAdjacentElement('afterend', link);
    else inner.insertBefore(link, inner.firstElementChild);
  }

  /* ──────────────────────────────────────────────────────────────────── */
  /* Mobil sticky araç çubuğu: sıralama çiplerini güncel tut              */
  /* ──────────────────────────────────────────────────────────────────── */

  function syncStickySortBar() {
    const source = document.querySelector('.utility-bar:not(.utility-bar--sticky-mobile-copy) .fh-sort-bar');
    const clone = document.querySelector('.utility-bar--sticky-mobile-copy .fh-sort-bar');
    if (source && clone && clone.innerHTML !== source.innerHTML) {
      clone.innerHTML = source.innerHTML;
    }
  }

  /* ──────────────────────────────────────────────────────────────────── */
  /* Çalıştır + AJAX sonrası yeniden çalıştır                             */
  /* ──────────────────────────────────────────────────────────────────── */

  function enhanceAll() {
    document.querySelectorAll('.filters__inner .filter-group').forEach((group) => {
      // Stok, fiyat ve sıralama grupları katlanmaz.
      if (group.classList.contains('filter-group--availability')) return;
      if (group.classList.contains('filter-group--applied')) return;
      if (group.classList.contains('filter-group--sort')) return;
      if (group.querySelector('price-range')) return;
      enhanceListGroup(group);
    });

    document.querySelectorAll('.filters__inner').forEach((inner) => {
      enhancePriceGroup(inner);
      ensureClearButton(inner);
    });
    syncStickySortBar();
  }

  /**
   * Symmetry'nin ajaxLoadForm'u `.filters` içindeki her input'u query string'e
   * çeviriyor. Arama kutuları filtre değeri olmadığı için, bir filtre
   * değişmeden HEMEN ÖNCE (capture fazı) boşaltılır; terim `searchTerms`'te
   * durur ve AJAX sonrası yeniden basılan kutuya geri yazılır.
   */
  function clearSearchInputs() {
    document.querySelectorAll('[data-farmahanem-filter-search]').forEach((input) => {
      input.value = '';
    });
  }

  function init() {
    enhanceAll();

    document.addEventListener('change', (evt) => {
      const target = evt.target;
      if (!(target instanceof HTMLElement)) return;
      if (target.matches('[data-farmahanem-filter-search]')) return;
      if (target.closest('.filters')) clearSearchInputs();
    }, true);

    // main.js AJAX sonrası [data-ajax-container] içeriğini innerHTML ile
    // değiştiriyor ve hiçbir event yaymıyor — DOM'u izlemek tek güvenilir yol.
    const container = document.querySelector('filter-container');
    if (!container) return;

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        enhanceAll();
      });
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
